import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getGetConfigQueryOptions, getGetRunQueryOptions } from '@/api/generated/endpoints';
import { RouteErrorFallback } from '@/components/route-error-fallback';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { EditRunForm } from '@/features/runs/components/edit-run-form';

export const Route = createFileRoute('/_authenticated/runs/$runId/edit')({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.ensureQueryData(getGetRunQueryOptions(params.runId));
		void queryClient.ensureQueryData(getGetConfigQueryOptions());
	},
	errorComponent: (props) => <RouteErrorFallback {...props} fallbackMessageKey='error_load_run_details' />,
	component: EditRunRoute,
});

function EditRunRoute() {
	const { t } = useTranslation();
	const { runId } = Route.useParams();
	const navigate = useNavigate({ from: '/runs/$runId/edit' });

	return (
		<Card>
			<CardHeader className='flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
				<div>
					<CardTitle>{t('runs_edit_title')}</CardTitle>
					<CardDescription>{t('runs_edit_description')}</CardDescription>
				</div>

				<Button asChild variant='outline'>
					<Link to='/runs'>
						<ArrowLeft className='size-4' />
						{t('runs_back_to_list')}
					</Link>
				</Button>
			</CardHeader>

			<CardContent>
				<EditRunForm runId={runId} onSuccess={() => navigate({ to: '/runs' })} />
			</CardContent>
		</Card>
	);
}
